import { Component, Input, OnInit } from '@angular/core';
import { color } from 'html2canvas/dist/types/css/types/color';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-user-icon',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './user-icon.component.html',
	styleUrls: ['./user-icon.component.scss'],
})
export class UserIconComponent implements OnInit {
	@Input() index: number = 0;
	@Input() initialLetters: string = 'AN';
	randomBackgroundColors: string[] = [
		'#FFC799',
		'#ADE5BB',
		'#ADE5BB',
		'#FFBABA',
	];
	backgroundColor: string = '#873498';
	textColor: string = '#000000';
	previous_color_pos = 0;

	constructor() {}

	ngOnInit(): void {
		this.backgroundColor = this.getRandomColor();
		this.textColor = this.darkenHexColor(this.backgroundColor);
	}

	getRandomColor(): string {
		return this.randomBackgroundColors[
			this.index % this.randomBackgroundColors.length
		];
	}

	// Function to darken a hex color by a specified factor
	darkenHexColor(hex: string, factor: number = 2): string {
		try {
			// Remove the hash at the start if it's there
			hex = hex.replace(/^#/, '');

			// Ensure the hex string is valid
			if (hex.length !== 6) {
				throw new Error('Invalid hex color format');
			}

			// Parse r, g, b values
			let r = parseInt(hex.substring(0, 2), 16);
			let g = parseInt(hex.substring(2, 4), 16);
			let b = parseInt(hex.substring(4, 6), 16);

			// Darken each color component
			r = Math.max(0, Math.min(255, Math.floor(r / factor)));
			g = Math.max(0, Math.min(255, Math.floor(g / factor)));
			b = Math.max(0, Math.min(255, Math.floor(b / factor)));

			// Convert back to hex and ensure 2-digit format
			const darkenedHex = `#${((1 << 24) + (r << 16) + (g << 8) + b)
				.toString(16)
				.slice(1)}`;

			return darkenedHex;
		} catch (error) {
			console.error('Error darkening hex color:', error);
			return hex; // Return the original hex color in case of an error
		}
	}
}
